import { IF } from "@ui/if/if";
import { Loader } from "@ui/loader/loader";
import clsx from "clsx";
import type { ButtonHTMLAttributes, FunctionComponent, ReactNode } from "react";

import styles from "./button.module.scss";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	mode?: "primary" | "secondary" | "simple";
	size?: "l" | "m" | "s";
	isLoading?: boolean;
	iconLeft?: ReactNode;
	iconRight?: ReactNode;
	loaderColor?: "london" | "accent";
}

export const Button: FunctionComponent<ButtonProps> = ({
	children,
	mode = "primary",
	iconLeft,
	iconRight,
	isLoading,
	size = "l",
	className,
	loaderColor = "london",
	...rest
}) => {
	const buttonStyles = clsx(
		styles.button,
		styles[mode],
		{
			[styles.large]: size === "l",
			[styles.medium]: size === "m",
			[styles.small]: size === "s",
		},
		className,
	);

	if (isLoading) {
		return (
			<button key="btn" {...rest} className={buttonStyles}>
				<Loader size={"m"} color={loaderColor} wrap={false} />
			</button>
		);
	}

	return (
		<button {...rest} key="btn" className={buttonStyles}>
			<IF condition={isLoading ?? false}>
				<Loader size={"m"} color={loaderColor} wrap={false} />
			</IF>
			<IF condition={!isLoading}>
				{iconLeft}
				{children}
				{iconRight}
			</IF>
		</button>
	);
};
